import { render, staticRenderFns } from "./PrintQRRelasi.vue?vue&type=template&id=78add863"
import script from "./PrintQRRelasi.vue?vue&type=script&lang=js"
export * from "./PrintQRRelasi.vue?vue&type=script&lang=js"
import style0 from "./PrintQRRelasi.vue?vue&type=style&index=0&id=78add863&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports